import React from 'react';
import { Box, Stack, Typography, Switch, TextField, FormControlLabel } from '@mui/material';
const DAYS_OF_WEEK = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
const DAYS_DISPLAY = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const HoursEditor = ({
  hours,
  onHoursChange,
  getDayHours,
  title = "Store Hours",
  description = "Specify the open and close times for each day of the week.",
  errors = null
}) => {
  const handleHoursChange = (dayIndex, field, value) => {
    if (onHoursChange) {
      onHoursChange(dayIndex, field, value);
    }
  };
  return <Box>
      <Typography variant="subtitle1" sx={{
      mb: 2
    }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{
      mb: 3
    }}>
        {description}
      </Typography>

      {errors && <Typography variant="caption" color="error" sx={{
      mb: 2,
      display: 'block'
    }}>
          {errors}
        </Typography>}

      <Stack spacing={1}>
        {DAYS_DISPLAY.map((dayName, dayIndex) => {
        const dayHours = getDayHours ? getDayHours(dayIndex) : null;
        const isOpen = !!dayHours;
        return <Box key={dayName} sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          py: 1,
          borderBottom: '1px solid #f0f0f0'
        }}>
              <Typography variant="body2" sx={{
            minWidth: '100px',
            fontWeight: '500'
          }}>
                {dayName}
              </Typography>

              <FormControlLabel control={<Switch checked={isOpen} onChange={e => handleHoursChange(dayIndex, 'is_open', e.target.checked)} size="small" />} label={isOpen ? "Open" : "Closed"} sx={{
            minWidth: '100px'
          }} />

              {isOpen && <>
                  <TextField type="time" label="Open" value={dayHours?.open_time?.slice(0, 5) || '09:00'} onChange={e => handleHoursChange(dayIndex, 'open_time', e.target.value + ':00')} size="small" inputProps={{
              step: 900 // 15 minutes in seconds (15 * 60 = 900)
            }} sx={{
              minWidth: '140px',
              '& .MuiInputBase-root': {
                cursor: 'pointer'
              },
              '& .MuiInputBase-input': {
                cursor: 'pointer'
              }
            }} onClick={e => {
              // Focus the input to open time picker
              e.target.focus();
            }} />

                  <TextField type="time" label="Close" value={dayHours?.close_time?.slice(0, 5) || '17:00'} onChange={e => handleHoursChange(dayIndex, 'close_time', e.target.value + ':00')} size="small" inputProps={{
              step: 900 // 15 minutes in seconds (15 * 60 = 900)
            }} sx={{
              minWidth: '140px',
              '& .MuiInputBase-root': {
                cursor: 'pointer'
              },
              '& .MuiInputBase-input': {
                cursor: 'pointer'
              }
            }} onClick={e => {
              // Focus the input to open time picker
              e.target.focus();
            }} />
                </>}
            </Box>;
      })}
      </Stack>
    </Box>;
};
export default HoursEditor;
export { DAYS_OF_WEEK, DAYS_DISPLAY };